import { toast } from 'react-toastify';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { selectedCompanyStorage } from '../../storage/company/index';
import { useAppMutation } from '../use-app-mutation.hook';
import { useLocale } from '../use-locale.hook';

export const useToggleAccess = () => {
  const companyId = selectedCompanyStorage(({ companyId }) => companyId);
  const { messagesLocale } = useLocale();

  const { mutate: toggleAccess, isPending } = useAppMutation([QueryKey.TOGGLE_STAKEHOLDER_ACCESS], {
    mutationFn: ({ stakeholderId }: { stakeholderId: string }) =>
      ApiService.post({
        endpoint: BackendRoute.COMPANIES,
        routePath: [companyId, 'stakeholders', stakeholderId, 'toggle-access'],
      }),
    onSuccess: () => {
      toast.success(messagesLocale['ACCESS_SUCCESSFULLY_CHANGED']);
    },
  });
  return { toggleAccess, isPending };
};
